export default {"src":"/_next/static/media/just_the_c.fc32ff01.svg","height":89,"width":78};